import { useLayoutEffect } from 'haunted/lib/core';

import { component } from '../../utils';

function SliderSlide(el: HTMLElement): null {
  useLayoutEffect(() => {
    el.classList.add('keen-slider__slide');
  }, []);

  return null;
}

export const SliderSlideElement = component(SliderSlide, {
  useShadowDOM: false,
});
